import { IPtw } from '@relab/alstom-ptw-shared';

import { ActionType, AppActionTypes } from '../types';

export function ptwCreateAction(
  ptw: Partial<IPtw>,
  files?: { descriptionFile?: string; ehsFile?: string }
): AppActionTypes {
  const data = new FormData();
  if (!!files.descriptionFile) {
    data.append('descriptionFile', files.descriptionFile);
  }
  if (!!files.ehsFile) {
    data.append('ehsFile', files.ehsFile);
  }
  data.append('ptw', JSON.stringify(ptw));

  return {
    type: ActionType.PTW_CREATE,
    payload: {
      request: {
        url: '/ptw',
        method: 'post',
        data,
      },
    },
  };
}

export function ptwAction(ptwId: string): AppActionTypes {
  return {
    type: ActionType.PTW,
    payload: {
      request: {
        url: `/ptw/${ptwId}`,
        method: 'get',
      },
    },
  };
}

export function ptwEditAction(ptw: Partial<IPtw>): AppActionTypes {
  return {
    type: ActionType.PTW_EDIT,
    payload: {
      request: {
        url: `/ptw/${ptw._id}`,
        method: 'post',
        data: {
          ...ptw,
        },
      },
      ptw: {
        ...ptw,
      },
    },
  };
}

export function ptwUpdateAction(ptw: IPtw): AppActionTypes {
  return {
    type: ActionType.PTW_UPDATE,
    payload: {
      ptw,
    },
  };
}

export function ptwAddFileAction(ptw: Partial<IPtw>): AppActionTypes {
  const { files, ...otherProps } = ptw;

  const data = new FormData();
  // data.append("file", files[0]);
  data.append('ptw', JSON.stringify(otherProps));

  return {
    type: ActionType.PTW_EDIT,
    payload: {
      request: {
        url: `/ptw/${ptw._id}`,
        method: 'post',
        data,
      },
      ptw: {
        ...ptw,
      },
    },
  };
}

export function ptwDeleteAction(ptwId: string): AppActionTypes {
  return {
    type: ActionType.PTW_DELETE,
    payload: {
      request: {
        url: `/ptw/${ptwId}`,
        method: 'delete',
      },
      ptw: {
        _id: ptwId,
      },
    },
  };
}
